export default "__VITE_ASSET__Bo8nvCn9__";